module.exports = class ReviewCounts {
    constructor() {
        this.premium            = 0;
        this.publisherSupplier  = 0;
    }
};
